/** @format */
import { ProductSearchResultsType } from '../../types';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const NULL_SEARCH_RESULTS: ProductSearchResultsType = {
    results: [],
    resultCount: 0,
    totalResults: -1,
    spellcheck: {
        suggestions: [],
    },
    sort: {},
};
